import React, { useState, useEffect } from "react";
import styles from "./TemplateHero29.module.css";

const TemplateHero29 = ({ branding, heroData }) => {
  const [current, setCurrent] = useState(0);
  const [reveal, setReveal] = useState(true);

  const slides = heroData?.slides || [];

  useEffect(() => {
    if (slides.length <= 1) return;

    const t = setInterval(() => {
      setReveal(false);

      setTimeout(() => {
        setCurrent((p) => (p + 1) % slides.length);
        setReveal(true);
      }, 400);
    }, 5500);

    return () => clearInterval(t);
  }, [slides.length]);

  if (!slides.length) return null;

  const tornPath =
    "M0,0 L0,100 L5,92 L10,98 L18,88 L24,96 L30,85 L36,94 L44,80 L50,91 L56,78 L63,90 L70,76 L75,88 L82,72 L88,85 L94,70 L100,82 L100,0 Z";

  const slide = slides[current];

  const titleParts = slide.title.split(" ");

  return (
    <div className={styles.root}>
      {/* LEFT PANEL */}
      <div className={styles.left}>
        <div
          className={styles.overline}
          style={{ opacity: reveal ? 1 : 0 }}
        >
          <div className={styles.overlineBar} />

          <span className={styles.overlineText}>
            {branding?.companyName || "Travel Co."}
          </span>
        </div>

        <h1
          className={styles.title}
          style={{
            opacity: reveal ? 1 : 0,
            transform: reveal ? "translateX(0)" : "translateX(-18px)",
          }}
        >
          {titleParts.slice(0, 2).join(" ")}

          <span className={styles.titleEm}>
            {titleParts.slice(2).join(" ")}
          </span>
        </h1>

        <div className={styles.dividerRow}>
          <div className={styles.divShort} />

          <span className={styles.divNum}>
            0{current + 1}
          </span>

          <div className={styles.divLong} />
        </div>

        <p
          className={styles.sub}
          style={{ opacity: reveal ? 1 : 0 }}
        >
          {slide.subtitle}
        </p>

        <div className={styles.actions}>
          <button className={styles.btnFire}>
            Book Journey
          </button>

          <button className={styles.btnWire}>
            Explore All
          </button>
        </div>

        {/* Torn edge */}
        <div className={styles.tear}>
          <svg
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
          >
            <path
              d={tornPath}
              fill="var(--header-bg,#111827)"
            />
          </svg>
        </div>

        {/* Nav */}
        <div className={styles.nav}>
          {slides.map((_, i) => (
            <div
              key={i}
              className={`${styles.ndot} ${
                i === current ? styles.activeDot : ""
              }`}
              onClick={() => setCurrent(i)}
            />
          ))}
        </div>
      </div>

      {/* RIGHT PHOTO */}
      <div className={styles.right}>
        {slides.map((s, i) => (
          <div
            key={i}
            className={styles.photo}
            style={{
              backgroundImage: `url('${s.image}')`,
              opacity: i === current ? (reveal ? 1 : 0.8) : 0,
            }}
          />
        ))}

        <div className={styles.photoGrade} />

        <div className={styles.counterBadge}>
          <div className={styles.cbNum}>
            0{current + 1}
          </div>

          <div className={styles.cbTotal}>
            of {slides.length}
          </div>
        </div>

        <div className={styles.caption}>
          <div className={styles.capLabel}>
            Now Featuring
          </div>

          <div className={styles.capTitle}>
            {slide.title}
          </div>
        </div>

        <div className={styles.photoNav}>
          <button
            className={styles.pnavBtn}
            onClick={() =>
              setCurrent(
                (p) =>
                  (p - 1 + slides.length) %
                  slides.length
              )
            }
          >
            ←
          </button>

          <button
            className={styles.pnavBtn}
            onClick={() =>
              setCurrent(
                (p) => (p + 1) % slides.length
              )
            }
          >
            →
          </button>
        </div>
      </div>
    </div>
  );
};

export default TemplateHero29;